import { Link } from "react-router-dom";
import loginLogo from "../../assets/logiscreen.png";

const VerifyOtpPage = () => {
  return (
    <div className="h-screen w-screen overflow-hidden bg-white">
      {/* ✅ Desktop View */}
      <div className="hidden md:flex flex-row items-center justify-center h-screen p-8 bg-white">
        {/* Left: Logo */}
        <div className="md:w-1/2 w-full md:flex justify-center items-center">
          <img src={loginLogo} alt="Illustration" className="md:w-3/4" />
        </div>

        {/* Right: OTP Form */}
        <div className="w-full md:w-1/2 max-w-md">
          <h2 className="text-xl font-bold mb-4 text-center">Verify Your Mobile/Email</h2>
          <p className="text-sm text-gray-600 mb-2 text-center">
            OTP has been sent to your number{" "}
            <span className="text-primary">+91 **********</span>. Enter the code to continue.
          </p>
          <form className="space-y-3">
            <div className="flex justify-between gap-2">
              {[...Array(4)].map((_, i) => (
                <input
                  key={i}
                  type="text"
                  maxLength={1}
                  className="md:w-24 md:h-24 w-12 h-12 p-2 border rounded-md text-center"
                />
              ))}
            </div>
            <Link
              to="/success"
              className="w-full block bg-primary text-white text-center py-2 rounded-md"
            >
              Submit
            </Link>
          </form>
          <p className="text-xs text-center mt-2 text-red-500">Resend code in 60 sec</p>
        </div>
      </div>

      {/* ✅ Mobile View */}
      <div className="md:hidden relative h-full w-full">
        {/* Background Image */}
        <div
          className="absolute inset-0 z-0 w-full h-full"
          style={{
            backgroundImage: `url(${loginLogo})`,
            backgroundSize: "contain",
            backgroundPosition: "top center",
            backgroundRepeat: "no-repeat",
          }}
        />

        {/* Black overlay with opacity */}
        <div className="absolute inset-0 bg-black opacity-70 z-0" />

        {/* Bottom Popup */}
        <div className="absolute bottom-0 left-0 right-0 z-20 bg-white rounded-t-3xl px-6 pt-4 pb-6 shadow-2xl max-h-[80%] overflow-y-auto">
          {/* Handle bar */}
          <div className="w-14 h-1.5 bg-gray-300 rounded-full mx-auto mb-4" />

          {/* Title */}
          <h2 className="text-xl font-bold mb-4 text-center">Verify Your Mobile/Email</h2>
          <p className="text-sm text-gray-600 mb-2 text-center">
            OTP has been sent to your number{" "}
            <span className="text-primary">+91 **********</span>. Enter the code to continue.
          </p>

          {/* OTP Input */}
          <form className="space-y-3 mt-4">
            <div className="flex justify-between gap-2">
              {[...Array(4)].map((_, i) => (
                <input
                  key={i}
                  type="text"
                  maxLength={1}
                  className="w-12 h-12 p-2 border rounded-md text-center"
                />
              ))}
            </div>
            <Link
              to="/success"
              className="w-full block bg-primary text-white text-center py-2 rounded-md mt-4"
            >
              Submit
            </Link>
          </form>

          <p className="text-xs text-center mt-2 text-red-500">Resend code in 60 sec</p>
        </div>
      </div>
    </div>
  );
};

export default VerifyOtpPage;
